import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Plus } from '@phosphor-icons/react';
import { AddWebpageModalV2 } from './AddWebpageModalV2';

/**
 * Floating Action Button component to trigger the Add Webpage modal.
 * Visible only on mobile screens (< md breakpoint).
 */
export function AddWebpageFab() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-50 block md:hidden">
      <AddWebpageModalV2
        open={isOpen}
        onOpenChange={setIsOpen}
        trigger={
          <Button 
            variant="default"
            className="h-14 w-14 rounded-full p-0 bg-primary hover:bg-blue-600 active:bg-blue-700 shadow-lg"
            aria-label="Save a webpage"
          >
            <Plus weight="bold" className="h-6 w-6 text-primary-foreground" /> 
          </Button>
        }
      />
    </div>
  );
}
